import { getColors } from "./colors";
import { getFontFamily, getFontStyles } from "./fonts";
import { getBorderRadius } from "./helpers";

export const spacings = {
  mobile: {
    small: "2.5vw",
    medium: "5vw",
    large: "7.5vw",
    x_large: "10vw",
  },
  desktop: {
    x_small: "5vw",
    small: "10vw",
    medium: "15vw",
    large: "20vw",
    x_large: "25vw",
    xx_large: "30vw",
  },
};
const jssVariables = {
  normal_gap: ".75rem",
  half_gap: ".375rem",
  double_gap: "1.5rem",
  navbar_height: "4rem",
  card_img_height_mobile: "12rem",
  card_img_height_desktop: "15rem",
  card_img_width_desktop: "38%",
  spacing: {
    center_padding_mobile_small: [0, spacings.mobile.small],
    center_padding_mobile_medium: [0, spacings.mobile.medium],
    center_padding_mobile_large: [0, spacings.mobile.large],
    center_padding_mobile_x_large: [0, spacings.mobile.x_large],
    // ===============================================================
    center_padding_x_small: [0, spacings.desktop.x_small],
    center_padding_small: [0, spacings.desktop.small],
    center_padding_medium: [0, spacings.desktop.medium],
    center_padding_large: [0, spacings.desktop.large],
    center_padding_x_large: [0, spacings.desktop.x_large],
    center_padding_xx_large: [0, spacings.desktop.xx_large],
    // ===============================================================
    center_margin_mobile_small: [0, spacings.mobile.small],
    center_margin_mobile_medium: [0, spacings.mobile.medium],
    center_margin_mobile_large: [0, spacings.mobile.large],
    // ===============================================================
    center_margin_small: [0, spacings.desktop.small],
    center_margin_medium: [0, spacings.desktop.medium],
    center_margin_large: [0, spacings.desktop.large],
    // ===============================================================
    section_padding_mobile: ["2rem", 0],
    section_padding: ["3rem", 0],
    // ===============================================================
    section_margin_mobile_small: ["2rem", 0],
    section_margin_mobile: ["3rem", 0],
    section_margin: ["3rem", 0],
  },
  media: {
    smallscreen: "screen and (min-width: 1024px)",
    bigscreen: "screen and (min-width: 1441px)",
    retina:
      "only screen and (-webkit-min-device-pixel-ratio: 2) and (min-width: 1024px)",
    // retina:
    //   "screen and (-webkit-min-device-pixel-ratio: 2) and (max-resolution: 192dpi) and (orientation: landscape)",
  },
  shadows: {
    title_text_shadow: "2px 2px 4px rgba(0, 0, 0, 0.5)",
    smallShadow: "2px 2px 10px rgba(0, 0, 0, 0.2)",
    normalShadow: "2px 2px 20px rgba(0, 0, 0, 0.2)",
    floatingShadow: "1px 4px 10px rgba(0, 0, 0, 0.15)",
    hoverShadow: "4px 4px 20px rgba(0, 0, 0, 0.4)",
  },
  colors: getColors(),
  fontsStyles: getFontStyles(),
  fontFamily: getFontFamily(),
  border_radius: getBorderRadius(),
};

export const vanessa_assets_s3_url =
  "https://vanessa-media.s3.eu-west-2.amazonaws.com/assets";

export const buttonStylesType1 = {
  border: `1px solid ${jssVariables.colors.base_color}`,
  borderRadius: "6px",
  padding: `calc(${jssVariables.normal_gap} * .3) calc(${jssVariables.normal_gap} * 1)`,
  cursor: "pointer",
  background: jssVariables.colors.base_color,
  color: jssVariables.colors.text.light,
  fontSize: "small",
  fontWeight: "bold",
  borderColor: jssVariables.colors.base_color,
};

export const mainMenuBtn = {
  cursor: "pointer",
  background: "none",
  color: jssVariables.colors.base_color,
  fontSize: "xx-large",
  padding: 0,
};

export default jssVariables;
